module.exports = "/* eslint-disable no-var, no-unused-vars */\nwindow.YP = {\n  Guichet: {},\n  Cart: []\n};"